
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/applovin",
      function () {
        return require("private-next-pages/destinations/applovin.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/applovin"])
      });
    }
  